export interface PartialDate {
  day?: string;
  month?: string;
  year?: string;
}

export const dateFormat: Required<PartialDate> = {
  year: 'YYYY',
  month: 'MM',
  day: 'DD'
};

export const pickerFormat: Required<PartialDate> = {
  year: 'Y',
  month: 'm',
  day: 'd'
};

export const getIntlDateFormat = (
  parts: Intl.DateTimeFormatPart[],
  format: Required<PartialDate>,
  space?: boolean
) =>
  parts
    .slice(0, 5)
    .map(({ type, value }) => format[type as keyof PartialDate] || value.replace(' ', ''))
    .join(space ? ' ' : '');
